
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useEffect, useState } from "react";
import * as yup from 'yup';
import { useFormik } from "formik";
import { BackButton, CancelButton, SubmitButton } from "../../../../Components/Utils/Buttons";
import FormikSelectTwo, { SelectProductWithError } from "../../../../Components/Utils/Select";
import { NuDate, NuInput, NuInputWithError } from "../../../../Components/Utils/Input";
import useEditFormData from "../../../../Components/Hooks/useEditFormData";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import { useToast } from "../../../../Components/Others/ToastServices";
import Attachement, { videotype } from "../../../../Components/Utils/CustomAttrachmentupload";
import Pdf from "../../../../Components/Icons/Pdf";
import Txt from "../../../../Components/Icons/Txt";
import Xls from "../../../../Components/Icons/Xls";
import Doc from "../../../../Components/Icons/Doc";
import Video from "../../../../Components/Icons/Video";
import CloseIcon from "../../../../Components/Icons/Close";
import DropDownAddMetaData, { DropDownAddUnitWithError } from "../../../../Components/Utils/selectAddMetaData";
import UseProductDropDownNew from "../../../../Components/Hooks/useProductSearch";
import DeleteIcon from "../../../../Components/Icons/Delete";
import EditIcon from "../../../../Components/Icons/Edit";
import Select from "react-select";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import UseDropDownNew from "../../../../Components/Hooks/useDropDownNew";
import MultiSelect from "../../../../Components/Utils/MultiSelect";
import axiosInstance from "../../../../Services/axiosCommon";

function EditContracts() {
  const navigate = useNavigate();

    const { contractsEditId } = useParams();
  
    const location = useLocation();
    // const data = location.state.data;
  const cdata = location.state?.data;
  const [data] = useState(cdata? cdata:null); 

      const { data: client } = UseDropDown(`/clients/drop-down`);
  const [search, setSearch] = useState("");

      const { data: Item , setData } = UseProductDropDownNew(`/equipments/drop-down`,search);
      const { value: unit,getData:refunit } = useFetchMataData(
        `/dropdown/dropdown-details/`,
        "unit_equipments"
      );
      // const { value: Duration,getData:refDuration } = useFetchMataData(
      //   `/dropdown/dropdown-details/`,
      //   "Duration_Contracts"
      // );
      // const { value: inspectionType,getData:refinspectionType } = useFetchMataData(
      //   `/dropdown/dropdown-details/`,
      //   "Inspection_Type_Contracts"
      // ); 
      const { value: status,getData:refstatus } = useFetchMataData(
        `/dropdown/dropdown-details/`,
        "Status_Contracts"
      ); 
  const from = location.state.from;
  const { data: form } = UseDropDownNew(`/form/drop-down`);

  const { Oncancel, editFormData, contextHolder, isLoading } =
  useEditFormData();
const [items, setItems] = useState([]);
const [remove, setRemove] = useState([]);
const [isEditQua, setIsEditQua] = useState(false);
const [isEditUnit, setIsEditUnit] = useState(false);
const [combinedItems, setCombinedItems] = useState([]);
const [sortedProList,setSortedProList] =  useState([]);
  const [oldData, setOldData] = useState([])
  const [dataa, setDatas] = useState(data);
  const { data: Survey } = UseDropDown(`/survey-report/drop-down`);
 
    const [newItemData, setNewItemData] = useState({
      equipmentId:"",
       unit:"",
       sno:"",
       quantity:""
    });
     const [createNew, setCreateNew] = useState([]);

  function getView() {
    axiosInstance 
      .get(`/contract/${contractsEditId}`)
      .then((res) => {
        setCreateNew({
          clientId: res.data?.data?.clientId  || "",
          date: res.data?.data?.datadate  || "",
          duration: res.data?.data?.dataduration  || "",
          startDate: res.data?.data?.datastartDate  || "",
          endDate: res.data?.data?.endDate  || "",
          renewalDate: res.data?.data?.renewalDate  || "",
          description: res.data?.data?.description  || "",
          inspectionType: res.data?.data?.inspectionType  || "",
          EquipmentId: res.data?.data?.EquipmentId  || "",
          srId: res.data?.data?.srId  || null,
          amount: res.data?.data?.amount  || "",
          formSelection: res.data?.data?.formSelection  || "",
          status: res.data?.data?.status  || "",
          filesToRemove:[]
        });       
      })
      .catch(err=>{
        console.log("err", err);
      })
  }
  
  useEffect(() => {
    // if (!cdata) {
      getView();
    console.log(createNew,"createnew");

    // }
  }, [])
  const handleDelete = (equipmentId) => {
    const updatedequipments = dataa?.equipments.filter(
      (item) => item.equipmentId !== equipmentId
    );
    // const deletedItem = dataa?.equipments.find(item => item.equipmentId === equipmentId);
    console.log(updatedequipments, "lll");

    setDatas((prevState) => ({
      ...prevState,
      equipments: updatedequipments,
    }));
    setRemove([...remove, equipmentId]);

    // setremove(prevState => ({
    //   ...prevState,
    //   removedProducts: [...prevState.removedProducts, deletedItem]
    // }));
  };
  const [error, setError] = useState("");
  const [productError, setProductError] = useState("");
  const [unitError, setUnitError] = useState("");
  const [quantityError, setQuantityError] = useState("");
  const handleAdd = () => {
    let hasError = false;

    if (!formik.values.equipmentId) {
      setProductError("Equipment is required");
      hasError = true;
    } else {
      setProductError("");
    }

    if (!formik.values.unit) {
      setUnitError("Unit is required");
      hasError = true;
    } else {
      setUnitError("");
    }

    if (!formik.values.quantity) {
      setQuantityError("Quantity is required");
      hasError = true;
    } else {
      setQuantityError("");
    }

    if (hasError) return;

    if (formik.values.equipmentId && formik.values.quantity) {
      const selectedProduct = Item.find(
        (i) => i.value === formik.values.equipmentId

      );
      let equ = sortedProList.find((i) => i.value === formik.values.equipmentId);
      const newItem = {
        equipmentId: formik.values.equipmentId,
        name: equ.label,
        quantity: formik.values.quantity,
        sno: formik.sno,
        unit: formik.values.unit,
      };
      setItems([...items, newItem]);

      setNewItemData({
        equipmentId: "",
        unit: "",
        sno:"",
        quantity: "",
      });
      let updatedItems = Item.filter(
        (it) => it.value !== formik.values.equipmentId
      );
      setData(updatedItems);
      formik.values.equipmentId = "";
      formik.values.sno = "";
      formik.values.quantity = "";
      formik.values.unit = "";

      setError("");
    }
  };

  const handleQuantityChange = (e, index) => {
    const updatedQuantity = e.target.value;

    const updatedItems = items.map((item, idx) => {
      if (idx === index) {
        return { ...item, quantity: updatedQuantity };
      }
      return item;
    });

    setItems(updatedItems);
  };

  const handleDeleteItem = (indexToDelete) => {
    const updatedItems = items.filter((_, index) => index !== indexToDelete);
    let ddUpdatedItem = items.find((_, i) => i === indexToDelete);
    setItems(updatedItems);
    let tempDd = ddUpdatedItem.name;
    setData([...Item, tempDd]);
    // localStorage.setItem("items", JSON.stringify(updatedItems));
  };
   const [filePathList, setFilePathList] = useState([]);
        const [fileRemoveList, setFileRemoveList] = useState([]);
       const [image, setImage] = useState([]);
        const toast = useToast();
        const [removefilePathList, setRemoveFilePathList] = useState([]);
      const [isModalOpen, setIsModalOpen] = useState(false);
        const [selectedImage, setSelectedImage] = useState(null);
        const [fileExtention, setFileExtention] = useState("");
     const [selectedFile, setSelectedFile] = useState(null);
   
     function handleImageChange(e) {
        const maxFileSize = 200000000; // 200 MB
        const files = Array.from(e.target.files);
        let fileArr = [];
        files.map((item) => {
          if (item.size < maxFileSize) {
            fileArr.push(item);
          } else {
            toast.open({
              type: "warning",
              message: `File Size to big`,
              description: `${item.name} is Removed and not Uploaded`,
              // placement: "bottomRight",
            });
          }
        });
        let tempArr = [];
        setSelectedFile(fileArr);
        files.map((item) => {
          if (item.size < maxFileSize) {
            let fileName = item?.name;
            console.log("fname", fileName);
            // let fileExtention = fileName.split(".").reverse()[0];
            // if (filetype?.includes(fileExtention)) {
            tempArr.push(fileName);
            // } else {
            //   let x = URL.createObjectURL(item);
            //   tempArr.push(x);
            // }
          }
        });
        console.log(tempArr, "temp");
        setImage(tempArr);
      }
    
      useEffect(() => {
        if (
          data?.attachments !== null &&
          data?.attachments !== "None" &&
          data?.attachments !== "[]"
        ) {
          // console.log(data.attachments, "ghjkllgd");
          setFilePathList(data?.attachments);
    
          setRemoveFilePathList(data?.attachments);
        }
      }, [data]);
    
      function UpdateAttachmentList(item) {
        let filterList = filePathList.filter((itemList) => itemList.file !== item);
        let removeFile = filePathList.find((itemList) => itemList.file === item);
        console.log("llll", filterList);
        setFileRemoveList([...fileRemoveList, removeFile.file]);
        setFilePathList(filterList);
      }
      function handleImageClick(img) {
        let Ext = img?.file_name.split(".").reverse()[0];
        setSelectedImage(img);
        setFileExtention(Ext);
        setIsModalOpen(true);
      }
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
          }),
    onSubmit: async (value, { resetForm }) => {
      let formData = new FormData();
      const valueWithItems = {
        ...value,
        equipments: combinedItems,
       
        filesToRemove: fileRemoveList,
      };
      formData.append("json_data", JSON.stringify(valueWithItems));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
      editFormData(
        `/contract/edit-contract/${contractsEditId}`,
        formData,
        resetForm,
        from,
      );},
  });
  const selectedequipmentIds = [
    ...items.map((item) => item.equipmentId),
    ...(dataa?.equipments?.map((product) => product.equipmentId) || []),
  ];

  // Step 2: Filter out the selected products from the dropdown options
  const filteredOptions = Item.filter(
    (product) => !selectedequipmentIds.includes(product.value)
  );

  const [finalList, setFinalList] = useState(dataa?.equipments);

  const handleQuantityChangeAlredyExit = (e, index) => {
    const updatedItems = [...finalList];
    updatedItems[index].quantity = e.target.value;
    setFinalList(updatedItems);
    console.log("shsd", finalList);
  };

  const handleProductUnitChangeAlredyExit = (value, index) => {
    const updatedItems = [...finalList];
    updatedItems[index].unit = value?.value;
    setFinalList(updatedItems);
    console.log("shsd", finalList);
  };

  console.log("sss", dataa?.equipments);
  console.log("ddd", items);

  useEffect(() => {
    if (dataa?.equipments && items) {
      const mergedArray = [...dataa.equipments, ...items];
      setCombinedItems(mergedArray);
    }
  }, [dataa?.equipments, items]);

  console.log("fff", combinedItems);
  const handleProductUnitChange = (value, index) => {
    const updatedItems = items.map((item, idx) => {
      if (idx === index) {
        return { ...item, unit: value?.value };
      }
      return item;
    });
    setItems(updatedItems);
  };

  const removeImages = (value) => {
    console.log("value", value);
    let List = selectedFile.filter((item) => item?.name !== value);
    console.log("LIst", List);
    setSelectedFile([...List]);
    let tempArr = [];
    List.map((item) => {
      console.log("filestoremo",item);
      
      let fileName = item?.name;
      // console.log('fname',fileName);
      // let fileExtention =  fileName.split(".").reverse()[0]
      // if(filetype?.includes(fileExtention)){
      tempArr.push(fileName);
      // }else{
      //   let x = URL.createObjectURL(item)
      //   tempArr.push(x)
      // }
    });
    setImage(tempArr);
  };



  useEffect(()=>{
    const filterdItem = Item.filter(
      (drop) => !dataa?.equipments?.some((id) => id.equipmentId === drop.value)
    );
    if(Item){
      const union = Array.from(
        new Map([...filterdItem, ...oldData].map((item) => [item.value, item])).values()
      );
      let data = union.sort((a, b) => a.label.localeCompare(b.label))
      setSortedProList(data)
    }
    console.log("item",Item);
    
  },[Item])

  useEffect(() => {
    if (formik.values.equipmentId) {
      const findValue = sortedProList.filter((v) => formik.values?.equipmentId ==(v.value));
      console.log("final",findValue);
      
      setOldData(findValue);
    }
    console.log("Testing",formik.values.equipmentId);
  },[formik.values.equipmentId])


  




  return (
    <div className=" w-full h-full py-2 px-4 ">
         <div className="flex justify-between w-full ">  
           <Breadcrumb
                                          items={[
                                 
                                            
                                            {
                                              name: "Contracts",
                                              link:"/client-management/contracts"
                                             
                                            },
                                
                                            { name: "Edit" },
                                          ]}
                                        />      
        <BackButton />
      </div>
      
        <div className="w-full mx-auto h-[calc(100vh-151px)] overflow-y-auto bg-white rounded-xl overflow-hidden mt-4">
        <form onSubmit={formik.handleSubmit}>
        <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
            <div className="w-full">
              <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#3369ff] decoration-2 underline-offset-4">
                Contracts:
              </p>
            </div>
            <NuInput
               type="text"
               label="Description"
               placeholder="Type here"
               formik={formik}
               name="description"
               width="w-full md:w-2/3"
             />
             <FormikSelectTwo
               label="Client"
               Options={client}
               formik={formik}
               placeholder="Choose"
               name="clientId"
               isRequired={true}
               width="w-full md:w-1/3 md:-mt-2"
             />
              <FormikSelectTwo
               label="Survey Report"
               Options={Survey}
               formik={formik}
               placeholder="Choose"
               name="srId"
               isRequired={true}
               width="w-full md:w-1/3 md:-mt-2"
             />
               <NuDate
               label="Date"
               formik={formik}
               name="date"
               width="w-full md:w-1/3 md:-mt-2"
             />
             <NuInput
                            type="amount"
                            label="Amount"
                            placeholder="Amount"
                            formik={formik}
                            name="amount"
                            width="w-full md:w-1/3 md:-mt-2"
                          />
              <FormikSelectTwo
               label="Duration"
               Options={[
                { value: "1 Month", label: "1 month" },
                { value: "3 Months", label: "3 Months" },
                { value: "6 Months", label: "6 Months" },
                { value: "12 Months", label: "12 Months" },
                { value: "24 Months", label: "24 Months" },
                { value: "36 Months", label: "36 Months" },
               ]}
               formik={formik}
               placeholder="Choose"
               name="duration"
              
               width="w-full md:w-1/3 md:-mt-2"
             />
              <NuDate
               label="Contract Start Date"
               formik={formik}
               name="startDate"
               width="w-full md:w-1/3 md:-mt-2"
             />
              <NuDate
               label="Contract End Date"
               formik={formik}
               name="endDate"
               width="w-full md:w-1/3 md:-mt-2"
             />
              <NuDate
               label="Contract Renewal Date"
               formik={formik}
               name="renewalDate"
               width="w-full md:w-1/3 md:-mt-2"
             />
            
            
             
              <FormikSelectTwo
               label="Inspection Type"
               Options={
                [
                  { value: "Monthly", label: "Monthly" },
                  { value: "Quarterly", label: "Quarterly" },
                  { value: "Half-yearly", label: "Half-yearly" },
                  { value: "Yearly", label: "Yearly" },
                
                ]
               }
               formik={formik}
               placeholder="Choose"
               name="inspectionType"
               
               width="w-full md:w-1/3 md:-mt-2"
             />
              {/* <FormikSelectTwo
               label="Form Selection"
               Options={form}
               formik={formik}
               placeholder="Choose"
               name="formSelection"
               
               width="w-full md:w-1/3 md:-mt-2"
             /> */}

              <MultiSelect
                            label="Form Selection"
                            Options={form}
                            formik={formik}
                            placeholder="Choose"
                            name="formSelection"
                            isRequired={true}
                            width="w-full md:w-1/3 md:-mt-2"
                          />
            
              <DropDownAddMetaData
                            label="Status"
                            placeholder="Choose"
                            Options={status}
                            formik={formik}
                            name="status"
                            width="w-full md:w-1/3 md:-mt-2 "
                            getFunc={refstatus}
                            displayProperty={"status"}
                            propertyName={"status_Contracts"}
                            FixPosition={false}
                            PortalTarget={false}
              
                          />
             <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#3369ff] decoration-2 underline-offset-4">
                   Attachement :
                </p>
                <Attachement
                    handleChange={handleImageChange}
                    preview={image || ""}
                    width="w-full md:w-1/2"
                    label="Attach"
                    multiple={true}
                removeImages={removeImages}

                  />
              </div>
              <div className="md:flex justify-between mt-5 px-3 w-full">
                <div className="w-full flex gap-2 items-center flex-wrap">
                  {data?.attachments &&
                    filePathList?.map((imgs, idx) => {
                      console.log("img", imgs);
                      let Ext = imgs?.file_name.split(".").reverse()[0];
                      return (
                        <div
                          className=" w-20 h-9 my-2 relative flex justify-center items-center rounded-lg"
                          key={idx}
                          style={{
                            border: "1px solid gray",
                            borderColor:
                              "rgb(148 163 184 / var(--tw-bg-opacity))",
                          }}
                        >
                          <div
                            className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center  -top-2 -right-2 z-10"
                            onClick={() => UpdateAttachmentList(imgs?.file)}
                          >
                            <CloseIcon color="white" height="8" width="8" />
                          </div>
                          <div
                            className=" w-20 h-9 flex justify-center items-center rounded-lg overflow-hidden cursor-pointer"
                            onClick={() => handleImageClick(imgs)}
                          >
                            <div className=" w-8 h-8">
                              {videotype.includes(Ext) ? <Video /> : null}

                              {Ext === ("docx" || "doc" || "txt") ? (
                                <Doc />
                              ) : Ext === ("xlsx" || "xls") ? (
                                <Xls />
                              ) : Ext === "txt" ? (
                                <Txt />
                              ) : Ext === "pdf" ? (
                                <Pdf />
                              ) : Ext === "PDF" ? (
                                <Pdf />
                              ) : Ext === "pptx" ? (
                                <>No file</>
                              ) : (
                                <img src={imgs?.file} alt="#" width="120%" />
                              )}
                            </div>
                            <p className=" w-[50px] text-[11px] truncate">
                              {imgs?.file_name}
                            </p>
                          </div>
                        </div>
                      );
                    })}

                  
                </div>
              </div>

           
           
            
          </div>
        
        <div className="w-full mx-auto h-auto bg-white rounded-md overflow-hidden mt-4 ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap  overflow-y-auto mb-4">
              <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-baseColor-primary decoration-2 underline-offset-4">
                  Requested Items :
                </p>
              </div>
              <div className="w-full px-2 m-2 flex flex-col md:flex-row gap-y-3 md:gap-y-0 justify-start gap-3 border border-solid rounded-lg">
                <SelectProductWithError
                  type="text"
                  label="Equipment "
                  placeholder="Equipment "
                  Options={sortedProList}
                  formik={formik}
                  name="equipmentId"
                  width="w-full md:w-1/2 lg:w-[67%]"
                  ErrMessage={productError}
                  px="0"
                  handleClick={() => {}}
                  hasAddButton={false}
                  setSearch={setSearch}
                  FixPosition={false}
                  PortalTarget={false}
                />
                <DropDownAddUnitWithError
                  label="Unit"
                  placeholder="Choose"
                  Options={unit}
                  formik={formik}
                  name="unit"
                  width="w-full md:w-1/2 lg:w-1/4"
                  // getFunc={refUnit}
                  displayProperty={"Add Unit"}
                  propertyName={"unit_equipments"}
                  ErrMessage={unitError}
                  hasAddButton={false}
                  FixPosition={false}
                  PortalTarget={false}
                />
                <NuInputWithError
                  label="Quantity"
                  type="number"
                  formik={formik}
                  placeholder="Quantity"
                  name="quantity"
                  width="w-full md:w-1/2 lg:w-1/4 "
                  ErrMessage={quantityError}
                />

                <button
                  onClick={handleAdd}
                  type="button"
                  className=" p-1 mt-10 m-1 text-center h-8 cursor-pointer bg-baseColor-primary border border-solid border-white  text-xs font-medium  text-white  rounded-lg "
                >
                  Add
                </button>
              </div>
              <div className="w-full bg-white overflow-hidden mt-5">
                {error && (
                  <p className="text-xs font-semibold text-red-500">{error}</p>
                )}
                <div className="w-full py-3  bg-baseColor-primary flex justify-between rounded-lg px-6">
                  <p className="w-[5%]  text-left  text-white text-xs font-medium">
                    S.No{" "}
                  </p>

                  <p className=" w-[55%] text-left text-white text-xs font-medium">
                    Equipment
                  </p>
                  <p className=" w-[15%] text-center pl-4 text-white text-xs font-medium flex justify-center">
                    Unit
                    <span
                      className="pl-1 cursor-pointer"
                      onClick={() => {
                        setIsEditUnit((prv) => !prv);
                      }}
                    >
                      {isEditUnit === true && (
                        <EditIcon width={"14"} height={"14"} color="yellow" />
                      )}
                      {isEditUnit === false && (
                        <EditIcon width={"14"} height={"14"} />
                      )}
                    </span>
                  </p>
                  <p className=" w-[20%] text-center text-white text-xs font-medium flex justify-center">
                    Quantity
                    <span
                      className="pl-1 cursor-pointer"
                      onClick={() => {
                        setIsEditQua((prv) => !prv);
                      }}
                    >
                      {isEditQua === true && (
                        <EditIcon width={"14"} height={"14"} color="yellow" />
                      )}
                      {isEditQua === false && (
                        <EditIcon width={"14"} height={"14"} />
                      )}
                    </span>
                  </p>

                  <p className=" w-[5%] text-right text-white text-xs font-medium">
                    Action
                  </p>
                </div>
                {items?.length > 0 || dataa?.equipments?.length > 0 ? (
                  <div className="h-[calc(100vh-300px)] overflow-y-scroll">
                    {items.map((List, index) => {
                      return (
                        <div
                          key={index}
                          className="w-full py-2 flex justify-between px-6 odd:bg-white even:bg-slate-100"
                        >
                          <p className="w-[5%]  text-left   text-xs font-medium text-[#111537] py-2.5">
                            {index + 1}
                          </p>
                          <p className=" w-[55%] text-left  text-xs font-medium text-[#111537] py-2.5">
                            {List?.name}
                          </p>
                          <p className=" w-[15%] text-center pl-4  text-xs font-medium text-[#111537]">
                            <Select
                              value={
                                unit.find(
                                  (item) => item?.value == List?.unit
                                ) || List?.unit
                              }
                              options={isEditUnit ? unit : []}
                              className="w-full"
                              onChange={(value) =>
                                handleProductUnitChange(value, index)
                              }
                              isDisabled={!isEditUnit}
                            />
                          </p>

                          <p className=" w-[20%] text-center  text-xs font-medium text-[#111537] py-2.5">
                            <input
                              type="number"
                              className="w-11/12 mx-auto outline-none text-center"
                              value={List?.quantity || ""}
                              disabled={!isEditQua}
                              onChange={(e) => handleQuantityChange(e, index)}
                            />
                          </p>

                          <div className="w-[5%] text-right py-2.5">
                            <button
                              onClick={() => handleDeleteItem(index)}
                              type="button"
                              className="text-red-500 cursor-pointer  ml-4 border-none"
                            >
                              <DeleteIcon color="red" height={12} />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                    {dataa?.equipments?.map((List, index) => {
                      return (
                        <div
                          key={index}
                          className="w-full py-2 flex justify-between px-6 odd:bg-white even:bg-slate-100"
                        >
                          <p className="w-[5%]  text-left   text-xs font-medium text-[#111537] py-2.5">
                            {index + 1 + items.length}
                          </p>
                          <p className=" w-[55%] text-left  text-xs  font-medium text-[#111537] py-2.5">
                            {List?.name}
                          </p>
                          <p className=" w-[15%] text-center pl-4  text-xs font-medium text-[#111537]">
                            <Select
                              value={
                                unit.find(
                                  (item) => item?.value == List?.unit
                                ) || List?.unit
                              }
                              options={isEditUnit ? unit : []}
                              className="w-full"
                              onChange={(value) =>
                                handleProductUnitChangeAlredyExit(value, index)
                              }
                              isDisabled={!isEditUnit}
                            />
                          </p>
                          <p className=" w-[20%] text-center  text-xs font-medium text-[#111537] py-2.5">
                            <input
                              type="number"
                              className="w-11/12 mx-auto outline-none text-center"
                              value={List?.quantity}
                              disabled={!isEditQua}
                              onChange={(e) =>
                                handleQuantityChangeAlredyExit(e, index)
                              }
                            />
                          </p>

                          <div className="w-[5%] text-right py-2.5">
                            <button
                              onClick={() => handleDelete(List?.equipmentId)}
                              type="button"
                              className="text-red-500 cursor-pointer  ml-4 border-none"
                            >
                              <DeleteIcon color="red" height={12} />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="w-full text-center text-[#93949f]">
                    No Items here
                  </div>
                )}

                {/* </div> */}
              </div>
              <div className="w-full hidden md:block mx-auto my-4 mt-8 py-4">
                <div className="md:flex justify-end gap-4">
                  <CancelButton
                    handleClick={() => {
                      Oncancel();
                    }}
                  />
                  <SubmitButton isLoading={isLoading} />
                </div>
              </div>
            </div>
          </div>
      </form>
      </div>
    </div>
  );
}

export default EditContracts;